import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isNull from 'lodash/isNull';

// MUI
import Snackbar from 'material-ui/Snackbar';

// actions
import { showMessage } from './snackBarActions';

// selectors
import { getMessage } from './snackBarSelectors';

class SnackBar extends Component {
  render() {
    const { message, showMessage } = this.props;
    return (
      <Snackbar
        open={!isNull(message)}
        message={message || ''}
        action="close"
        autoHideDuration={3000}
        onActionTouchTap={() => showMessage({ message: null })}
      />
    );
  }
}

SnackBar.propTypes = {};
SnackBar.defaultProps = {};

const mapStateToProps = (state) => ({
  message: getMessage(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ showMessage }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SnackBar);



// WEBPACK FOOTER //
// ./src/store/snackbar/SnackBar.js